import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";



const enum fields {
    conditionlabel = "conditionlabel",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.conditionlabel]: string;
    };
}

type Props = WidgetProps & HasProduct;

export interface ProductDetailsConditionStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    fitContent?: InjectableCss;
}

export const conditionStyles: ProductDetailsConditionStyles = {
    labelText: {
        size: 14,
        weight: "bold",
        css: css`
            margin-right: .18750625rem;
            white-space: nowrap;
        `,
    },
    valueText: {
        size: 14,
        css: css`
            margin-bottom: .31250625rem;
        `,
    },
    fitContent: {
        css: css`
        width: fit-content;
        float:left;
        padding-right:.3rem;
         }
        `,
    },
};

const styles = conditionStyles;

const ProductDetailsCondition: React.FC<Props> = ({ fields, product }) => {
    if (!product.properties.condition) {
        return null;
    }

    return (
        <Typography {...styles.valueText} {...styles.fitContent} as="p" data-test-selector="ProductDetailsCondition">
            <Typography {...styles.labelText}>
                {translate(fields.conditionlabel) || translate("Condition:")}
            </Typography>
            {product.properties.condition}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsCondition),
    definition: {
        displayName: "Condition",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.conditionlabel,
                editorTemplate: "TextField",
                defaultValue: "Condition:",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
